/* global axios */
import ApiClient from './ApiClient';

class PlatformTooltipsAPI extends ApiClient {
  constructor() {
    super('platform_tooltips', { accountScoped: false });
  }
}

export default new PlatformTooltipsAPI();
